module.exports = __webpack_public_path__ + "img/abnormal.fedcb87a.png";